import { store } from '../../app/store'
import { crmApiSlice } from '../crm/crmApiSlice'
import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'

const Prefetch = () => {
    useEffect(() => {
        const files = store.dispatch(crmApiSlice.endpoints.getCrmList.initiate())

        return () => {
            files.unsubscribe()
        }
    }, [])
    return <Outlet />
}

export default Prefetch